<template>
  <div id="seleccion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <v-card flat v-if="tabSelected == 'Reclutados'">
                <candidatos-seleccion-tab
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></candidatos-seleccion-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Capacitacion'">
                <capacitacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></capacitacion-seleccion-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Contratacion'">
                <contratacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></contratacion-seleccion-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Asignacion'">
                <asignacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></asignacion-seleccion-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Aplicacion Seleccion'">
                <aplicacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></aplicacion-seleccion-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Evaluacion'">
                <evaluacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></evaluacion-seleccion-tab>
              </v-card>

              <!-- <v-card flat v-if="tabSelected=='Retribuciones'">
                <retribuciones-seleccion-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></retribuciones-seleccion-tab>
              </v-card> -->
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CandidatosSeleccionTab from "@/modules/aplicacion/views/seleccion/candidatos/CandidatosSeleccionTab.vue";
import CapacitacionSeleccionTab from "@/modules/aplicacion/views/seleccion/capacitacion/CapacitacionSeleccionTab.vue";
import ContratacionSeleccionTab from "@/modules/aplicacion/views/seleccion/contratacion/ContratacionSeleccionTab.vue";
import AsignacionSeleccionTab from "@/modules/aplicacion/views/seleccion/asignacion/AsignacionSeleccionTab.vue";
import AplicacionSeleccionTab from "@/modules/aplicacion/views/seleccion/aplicacion/AplicacionSeleccionTab.vue";
import EvaluacionSeleccionTab from "@/modules/aplicacion/views/seleccion/evaluacion/EvaluacionSeleccionTab.vue";
import RetribucionesSeleccionTab from "@/modules/aplicacion/views/seleccion/retribuciones/RetribucionesSeleccionTab.vue";

export default {
  name: "seleccion-sub-tab",

  components: {
    CandidatosSeleccionTab,
    CapacitacionSeleccionTab,
    ContratacionSeleccionTab,
    AsignacionSeleccionTab,
    AplicacionSeleccionTab,
    EvaluacionSeleccionTab,
    RetribucionesSeleccionTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: [
      "Reclutados",
      "Capacitacion",
      "Contratacion",
      "Asignacion",
      "Aplicacion Seleccion",
      "Evaluacion",
    ],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      if (this.$store.getters.subTabSelectedStored == "Aplicacion Seleccion") {
        let vispTab = "Visita Prevista";
        this.$store.commit("aplicacion_tab_state", vispTab);
      }
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },

    selected(tab) {
      if (tab == "Aplicacion Seleccion") {
        let vispTab = "Visita Prevista";
        this.$store.commit("aplicacion_tab_state", vispTab);
      }
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
